/**
 * 续费转介绍活动 业务逻辑工具函数
 * 纯函数，无副作用
 */

/* ──────────────── 类型定义 ──────────────── */

/** 状态弹窗触发判定所需的活动信息 */
export interface RenewalStatusTipsActInfo {
  activityType?: string;
  sceneLabel?: string;
  activityStatus?: string;
  includedCurrentUser?: boolean;
}

/* ──────────────── 工具函数 ──────────────── */

/**
 * 判断是否为续费转介绍活动
 * 判定规则：activityType === 'REFERRAL' 且 sceneLabel === 'REFERRAL_RENEWAL'
 * 任一参数缺省返回 false（安全降级，走原整页拦截逻辑）
 */
export function isRenewalReferralActivity(activityType?: string, sceneLabel?: string): boolean {
  return activityType === 'REFERRAL' && sceneLabel === 'REFERRAL_RENEWAL';
}

/**
 * 获取状态提示弹窗文案
 * PENDING → 活动未开始；其余（FINISH/其他/缺省）→ 活动已结束
 */
export function getStatusTipsText(activityStatus?: string): string {
  return activityStatus === 'PENDING' ? '活动未开始' : '活动已结束';
}

/**
 * 获取 canShare=false 时的 Toast 提示文案
 * GENERATE_POSTER_TRIAL_DIRECT（邀请直购/邀请体验分享按钮）→ 已过期；其余 → 您不可参与当前活动
 */
export function getCanShareToastText(reloadType?: string): string {
  return reloadType === 'GENERATE_POSTER_TRIAL_DIRECT' ? '已过期' : '您不可参与当前活动';
}

/**
 * 判断续费转介绍活动是否需要展示状态提示弹窗
 * 判定规则：续费转介绍活动 且 activityStatus ≠ 'PROCESSING' 且 includedCurrentUser === true
 */
export function shouldShowRenewalStatusTips(actInfo: RenewalStatusTipsActInfo): boolean {
  const { activityType, sceneLabel, activityStatus, includedCurrentUser } = actInfo;
  return (
    isRenewalReferralActivity(activityType, sceneLabel) &&
    activityStatus !== 'PROCESSING' &&
    includedCurrentUser === true
  );
}
